var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 2.4375C7.1875 2.4375 1.9375 7.74219 1.9375 14.25C1.9375 20.8125 7.1875 26.0625 13.75 26.0625C20.2578 26.0625 25.5625 20.8125 25.5625 14.25C25.5625 7.74219 20.2031 2.4375 13.75 2.4375ZM13.75 0.6875C21.1875 0.6875 27.3125 6.8125 27.3125 14.25C27.3125 21.7422 21.1875 27.8125 13.75 27.8125C6.25781 27.8125 0.1875 21.7422 0.1875 14.25C0.1875 6.8125 6.25781 0.6875 13.75 0.6875ZM13.0938 7.25H14.3516C14.7344 7.25 15.0078 7.57812 15.0078 7.96094L14.625 17.1484C14.625 17.4766 14.2969 17.75 13.9688 17.75H13.4766C13.1484 17.75 12.8203 17.4766 12.8203 17.1484L12.4375 7.96094C12.4375 7.57812 12.7109 7.25 13.0938 7.25ZM13.75 18.8438C14.5703 18.8438 15.2812 19.5547 15.2812 20.375C15.2812 21.25 14.5703 21.9062 13.75 21.9062C12.875 21.9062 12.2188 21.25 12.2188 20.375C12.2188 19.5547 12.875 18.8438 13.75 18.8438Z",
    fill: "#D22323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.97655c8c.svg";
export { ForwardRef as ReactComponent };